module.exports = __webpack_public_path__ + "img/bottom_icon05.55ca4b6.png";